// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"172":"c5d060b8","754":"85f96f3e","923":"a17a9afa","927":"94cc9ef7","948":"8b16877e"}[chunkId] + ".css";
};